import React, { useState, useLayoutEffect } from 'react';
import { Row, Col } from 'antd';
import { useLocation } from 'react-router-dom';
import { AdminNavbar } from '../layout/PageHeader';
import { AccountTypeContext } from '../dashboard/Dashboard';
import { MealItem } from '../meals/components/MealList';
import { Meal } from '../../store/meals/types';
import { colors } from '../../constants/colors';
import { capitalize } from 'lodash';

export interface ContentParams {
  state: any;
}

export const Content: React.FC<ContentParams> = ({ state }) => {
  const [width, setWidth] = useState<number>(0);
  useLayoutEffect(() => {
    const updateSize = () => {
      setWidth(window.innerWidth);
    };
    window.addEventListener('resize', updateSize);
    updateSize();
    return () => window.removeEventListener('resize', updateSize);
  }, []);
  const isDesktop = width >= 768;
  return (
    <Col xs={24} sm={24} md={24} lg={24} className="manage-user-container">
      <Row justify="space-between" className="header-wrap">
        <Col>
          <Col span={4}>
            <span style={{ color: colors.blue }}>Offers</span>
          </Col>
          <Col>
            <span>
              {state.users.name} / {capitalize(state.users.accountType)}{' '}
              {state.users.subAccountType === '' ? null : '/'}
              {capitalize(state.users.subAccountType)}
            </span>
          </Col>
        </Col>
      </Row>
      <div className={isDesktop ? 'grid-display' : ''}>
        {state.meals.map((item: Meal, i: string | number | undefined) => (
          <div key={i}>
            <MealItem meal={item} />
          </div>
        ))}
      </div>
    </Col>
  );
};

export const Offers: React.FC = () => {
  const [forWho, setForWho] = useState('Admin');
  const location = useLocation();
  const handleAccountTypeChange = () => {
    const tempForWho = forWho;
    setForWho(tempForWho);
  };
  return (
    <AccountTypeContext.Provider value={{ forWho, handleAccountTypeChange }}>
      <div className="admin">
        <Row justify="center">
          <AdminNavbar />
        </Row>
        <Row justify="center" className="orders-container">
          <Content state={location.state} />
        </Row>
      </div>
    </AccountTypeContext.Provider>
  );
};
